import { TemplateElement, html, defineElement, optionalAttribute } from '@webtides/element-js';
import style from './e-banking-picture.css';

/**
 * @property {ImageProperties} image
 */
export default class Picture extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            image: null,
            meta: null,
            inlineAspectRatio: true,
        };
    }

    get aspectRatioStyle() {
        if (!this.inlineAspectRatio || !this.meta?.width || !this.meta?.height) return '';
        const { width, height } = this.meta ?? {};
        return `aspect-ratio: ${parseInt(width)} / ${parseInt(height)}`;
    }

    template() {
        if (!this.image) return null;

        return html`
            <div class="relative rounded-md overflow-hidden">
                <img
                    class="w-full"
                    ${optionalAttribute(this.aspectRatioStyle, 'style', this.aspectRatioStyle)}
                    src="${this.image?.src}"
                    srcset="${this.image?.srcset}"
                    alt="${this.image?.alt}"
                    loading="lazy"
                />
            </div>
        `;
    }
}

defineElement('mb-e-banking-picture', Picture);
